import { useQuery } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import { GetFixDiscountsQuery } from "~/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query GetFixDiscounts {
		getFixDiscounts {
			_id
			name
			isOfferingHigherValue
			isDeactivated
			configs {
				type
				discountType
				discountValue

				products
				types
				options
				categories
				agents
				clients
			}
		}
	}
`;

export type GetFixDiscountsResults = GetFixDiscountsQuery["getFixDiscounts"];

export const getFixDiscountsQueryKey = () => ["getFixDiscounts"];

export const useGetFixDiscounts = (enabled?: boolean) => {
	return useQuery({
		enabled: enabled ?? true,
		queryKey: getFixDiscountsQueryKey(),
		queryFn: async () =>
			apiGqlClient.request(graphql(query)).then((res) => res.getFixDiscounts),
	});
};

export const useGetFixDiscountsCache = () => {
	return useGetFixDiscounts(false);
};
